import React,{Component} from 'react';
import {
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';

import BrandInfo from '../../BrandInfo';
import BrandSpecialPricing from '../../BrandSpecialPricing';
import ProviderCampaignList from "../../ProviderCampaignList";
import VerifiedPurchasesList from "../../VerifiedPurchasesList";
import EditVerifiedPurchase from "../../EditVerifiedPurchase";
import EditPromotion from "../../EditPromotion";
import PromotionList from "../../PromotionList";
import Button from "../../../shared/components/Button";

class BrandView extends Component {
  constructor(props){
    super(props);
    this.state = { loading:false};
  }

  componentDidMount(){
    if(!this.props.needsLoading){
      return
    }
    this.setState({loading:true})
    Promise.all([
      this.props.loadBrand(this.props.brandId),
      this.props.loadReceiptLineups(),
      this.props.loadPromotions()
    ]).then(() => this.setState({loading:false}))
  }


  render(){
    const {match,name,brandId,loading} = this.props;

    return (
      <Container>
        <Row>
          <Col xs='6'>
            <br />
            <h6>Brand</h6>
            <h3>{loading ? 'Loading...' : ''}</h3>
            <br />
          </Col>
          <Col xs='6' className='clearfix'>
            <br />
            <br />
            <div className='pull-right'>
              <Switch>
                <Route
                    exact path={`${match.url}/verifiedpurchases`}
                    render={() => (
                        <Button linkHref={`${match.url}/verifiedpurchases/new`}>
                          New Verified Purchase
                        </Button>
                    )}
                />
                <Route
                    exact path={`${match.url}/promotions`}
                    render={() => (
                        <Button linkHref={`${match.url}/promotions/new`}>
                          Add New
                        </Button>
                    )}
                />
              </Switch>
            </div>
            <br />
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <Nav tabs className='UnderLineTabs'>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/edit`}
                  activeClassName='active'
                >
                  Info
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/pricing`}
                  activeClassName='active'
                >
                  Pricing
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink

                  tag={Link}
                  to={`${match.url}/experiences`}
                  activeClassName='active'
                >
                  Experiences
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink

                    tag={Link}
                    to={`${match.url}/verifiedpurchases`}
                    activeClassName='active'
                >
                  Verified Purchases
                </NavLink>
              </NavItem>
              <NavItem>
              <NavLink

                  tag={Link}
                  to={`${match.url}/promotions`}
                  activeClassName='active'
              >
                Deals and Discounts
              </NavLink>
            </NavItem>
            </Nav>
          </Col>
        </Row>
        <br />
        {!loading && (
          <Switch>
            <Route
              path={`${match.url}/edit`}
              render={() => (<BrandInfo brandId={brandId} />)}
            />
            <Route
              path={`${match.url}/pricing`}
              render={() => (<BrandSpecialPricing brandId={brandId} />)}
            />
            <Route
                path={`${match.url}/experiences`}
                render={() => (<ProviderCampaignList brandId={brandId} backURL={`${match.url}/experiences`} />)}
            />
            <Route
                path={`${match.url}/verifiedpurchases/:receiptId`}
                render={() => (<EditVerifiedPurchase brandId={brandId} />)}
            />
            <Route
                path={`${match.url}/verifiedpurchases`}
                render={() => (<VerifiedPurchasesList brandId={brandId} />)}
            />
            <Route
                path={`${match.url}/promotions/:promotionId`}
                render={() => (<EditPromotion brandId={brandId} />)}
            />
            <Route
                path={`${match.url}/promotions`}
                render={() => (<PromotionList brandId={brandId} />)}
            />
          </Switch>
        )}
      </Container>
    )
  }
}

export default BrandView;



// WEBPACK FOOTER //
// ./src/routes/BrandView/components/BrandView.js